import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SERVICES } from '../data/staticData';
import { getServices } from '../lib/cmsClient';

export default function ServicesPage() {
  const [services, setServices] = useState(SERVICES);
  const [selectedCategory, setSelectedCategory] = useState('alle');

  useEffect(() => {
    async function load() {
      const data = await getServices();
      setServices(data);
    }
    load();
  }, []);

  const categories = ['alle', 'Nyt tag', 'Energiløsninger', 'Vedligeholdelse'];

  const filteredServices = selectedCategory === 'alle'
    ? services
    : services.filter(s => s.category?.toLowerCase() === selectedCategory.toLowerCase());

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-20 lg:pt-24 pb-20 sm:pb-28 lg:pb-36 space-y-16 sm:space-y-24">
      
      {/* Header */}
      <div className="text-left max-w-4xl space-y-6">
        <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 tracking-tight uppercase">
          Komplette Tag- og Energiløsninger
        </h1>
        <p className="text-stone-600 text-lg sm:text-xl leading-relaxed">
          Dansk Tagbyg udfører alle former for tagarbejde, isolering, montering af døre/vinduer samt udendørs vedligeholdelse for private og erhverv i hele Danmark.
        </p>
      </div>

      {/* Category Filter */}
      <div className="flex flex-wrap justify-center gap-2 pb-4">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            className={`px-4 py-2 rounded-none text-sm font-bold transition-all ${
              selectedCategory === cat
                ? 'bg-amber-600 text-white shadow-md'
                : 'bg-white text-stone-700 hover:bg-stone-100 border border-stone-200'
            }`}
          >
            {cat === 'alle' ? 'Alle ydelser' : cat}
          </button>
        ))}
      </div>

      {/* Services Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 lg:gap-12">
        {filteredServices.map((service) => (
          <div
            key={service.id}
            className="group rounded-none bg-white border border-stone-200 hover:border-amber-500/50 transition-all flex flex-col justify-between overflow-hidden shadow-sm hover:shadow-md"
          >
            <div>
              <div className="h-56 overflow-hidden relative">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded-none bg-stone-900/80 backdrop-blur-sm text-[11px] font-bold text-amber-300 border border-stone-700">
                  {service.category}
                </div>
              </div>

              <div className="p-8 space-y-4">
                <h2 className="text-xl font-bold text-stone-900 group-hover:text-amber-700 transition-colors">
                  {service.title}
                </h2>
                <p className="text-stone-600 text-xs sm:text-sm line-clamp-3 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>

            <div className="p-8 pt-0">
              <Link
                to={`/ydelser/${service.slug}`}
                className="w-full py-2.5 px-4 rounded-none bg-stone-100 hover:bg-amber-600 text-stone-800 hover:text-white font-bold text-xs flex items-center justify-center gap-2 transition-colors border border-stone-200 hover:border-amber-600"
              >
                <span>Læs om {service.title}</span>
                <i className="fa-solid fa-arrow-right"></i>
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* CTA Box */}
      <div className="bg-gradient-to-r from-amber-500/10 via-amber-500/5 to-stone-100 p-8 sm:p-10 rounded-none border border-amber-200 text-center space-y-4">
        <h3 className="text-2xl font-bold text-stone-900">Brug for hjælp til at vælge den rette tagtype?</h3>
        <p className="text-stone-600 text-sm max-w-2xl mx-auto">
          Prøv vores online prisberegner eller kontakt Lasse direkte for en uforpligtende snak om dit projekt.
        </p>
        <div className="flex flex-wrap justify-center gap-4 pt-2">
          <Link
            to="/prisberegner"
            className="px-6 py-3 rounded-none bg-stone-900 hover:bg-black text-white font-bold text-sm shadow-md"
          >
            Beregn pris på tag online
          </Link>
          <Link
            to="/kontakt"
            className="px-6 py-3 rounded-none bg-white hover:bg-stone-100 text-stone-800 font-bold text-sm border border-stone-300"
          >
            Kontakt os her
          </Link>
        </div>
      </div>

    </div>
  );
}
